import { Component, Input, OnInit } from '@angular/core';
import {
  CdkDragDrop,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import { TasksService } from 'src/app/business-service/tasks/tasks.service';
import { RECORD_STATUS_VALUES } from '../constants/api-constants';

@Component({
  selector: 'app-draggable-board',
  templateUrl: './draggable-board.component.html',
  styleUrls: ['./draggable-board.component.scss'],
})
export class DraggableBoardComponent implements OnInit {

  allTasksForLead:any;
  @Input() leadId:any;

  notStarted = [];
  inProgress = [];
  completed = [];
  onHold = [];
  cancelled = [];

  RECORD_STATUS_VALUES = RECORD_STATUS_VALUES;

  constructor(
    private _tasksService: TasksService
  ) { }

  ngOnInit() {
    if(this.leadId){
      this._tasksService.getAllTasksOfLead(this.leadId, 1, 1000, null).subscribe((data)=>{
        this.allTasksForLead = data.data;        
      })
    }

    
   }

   filterTaskOnStatus(status:any){    
    return this.allTasksForLead.filter((m: { status: any; }) => m.status === status);
   }


  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }

}
